import Multiselect from 'multiselect-react-dropdown';
import DateSelecter from '../../components/DateSelector/DateSelector';
import { Fragment, useEffect, useMemo, useState } from 'react';
import excel from 'exceljs';
import './dashboard.css';
import {
    get_dimensions,
    get_metrics,
    get_services,
} from '../../services/api.service';
import { formatDate } from 'date-fns';
import AddGraphical from '../../components/Popup/Add_Graphical';
import Loading from '../../components/Animation/Loading';
import Pagination from 'general/components/Pagination';
import { MultiaxisLineChart } from 'charts/MultiaxisLineChart';
import checkPermissionFunction from 'Permission';
import { get_Data_Good_Day_usage_data, get_Data_Good_Day_usage_graphical, get_getGoodDaySelectionWorkList } from 'services/GoodDayStatistics';
import { Button, Col, Row, Select } from 'antd';

const path = 'usetheservice';

const UseTheService = () => {
    //Multiselect
    const [UserType, setUserType] = useState([
        {
            "id": "0",
            "name": "Tất cả"
        },
        {
            "id": "2",
            "name": "Chưa đăng nhập"
        },
        {
            "id": "1",
            "name": "Đã đăng nhập"
        }
    ]);
    const [thingsToSee, setThingsToSee] = useState([]);
    const [isLoading, set_isLoading] = useState(true);

    //multiselected
    // const [selectedUserType, setSelectedUserType] = useState([]);
    const [selectedUserType, setSelectedUserType] = useState([{ id: 0 }]);
    const [selectedThingsToSee, setSelectedThingsToSee] = useState([]);

    //pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(20);

    //select
    const [selectedMetric, setSelectedMetric] = useState([1, 2]);
    const [selectDimension, setSelectedDimension] = useState(['', '']);

    //selected to apply
    const [UserType_Apply, set_UserType_Apply] = useState([{ id: 0 }]);
    const [thingsToSee_Apply, set_thingsToSee_Apply] = useState([]);

    //time
    const now = new Date();
    const [startDate, setStartDate] = useState(
        new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30)
    );
    const [titleDay, set_titleDay] = useState('30 ngày gần đây');
    const [endDate, setEndDate] = useState(now);
    const [startDate_Apply, set_startDate_Apply] = useState(
        new Date(now.getFullYear(), now.getMonth(), now.getDate() - 30),
        'dd/MM/yyyy'
    );
    const [endDate_Apply, set_endDate_Apply] = useState(now);
    const [showPickDate, set_pickDate] = useState(false);

    const onDateChange = (dates) => {
        setStartDate(dates.startDate);
        setEndDate(dates.endDate);
        set_titleDay(dates.selectedOption);
    };

    const onChangeSelect = async (e, type, index) => {
        set_isLoading(true);
        let list_Dimension = [...selectDimension];
        let list_Metric = [...selectedMetric];
        switch (type) {
            case 'dimension':
                if (e.target.value == '0') {
                    list_Dimension[index] = '';
                    setSelectedDimension(list_Dimension);
                    // console.log(list_Dimension);
                    break;
                }
                list_Dimension[index] = Number(e.target.value);
                // console.log(list_Dimension);
                setSelectedDimension(list_Dimension);
                break;
            case 'metric':
                console.log(list_Metric);
                list_Metric[index] = Number(e.target.value);
                // console.log(list_Metric);
                setSelectedMetric(list_Metric);
                break;
        }

        // console.log(selectedMetric);
        // console.log(selectDimension);
        const graphical_Statistics = await get_Data_Good_Day_usage_graphical({
            userTypeId: selectedUserType.map((item) => item.id),
            workIds: selectedThingsToSee.map((item) => item.id),
            startTime: formatDate(startDate, 'dd/MM/yyyy'),
            endTime: formatDate(endDate, 'dd/MM/yyyy'),
            metricIds: [list_Metric[index]],
            dimensionIds: list_Dimension[index] == '' ? [] : [list_Dimension[index]],
        });

        let list_graphical = [...list_graphical_Statistics];
        list_graphical[index] = graphical_Statistics.data.data;
        let units = [...list_unit];
        units[index] = graphical_Statistics.data.data.unit;
        set_list_Graphical_Statistics(list_graphical);
        set_list_Unit(units);

        set_isLoading(false);
    };
    const [service_packages, set_service_packages] = useState([]);
    const refresh_service_packages = (selectedList) => {
        onChangeSelectservicePackages([], []);
        const selectedToID = selectedList.map((item) => item.id.toString());
        if (selectedList.length == 0) {
            set_service_packages(thingsToSee);
            return;
        }
        set_service_packages(
            thingsToSee.filter((item) => selectedToID.includes(item?.service_id.toString()))
        );
    };

    //function multiselect
    const onChangeSelectMultiServices = (selectedList, selectedItem) => {
        setSelectedUserType(selectedList);
        refresh_service_packages(selectedList);
    };
    const onChangeSelectservicePackages = (selectedList, selectedItem) => {
        setSelectedThingsToSee(selectedList);
    };

    const [list_graphical_Statistics, set_list_Graphical_Statistics] = useState([]);
    const [list_unit, set_list_Unit] = useState([]);

    //table
    const [field_metrics, set_field_metrics] = useState([]);
    const [field_select_metrics, set_select_field_metrics] = useState([]);
    const [field_dimensions, set_field_dimensions] = useState([]);
    const [field_select_dimensions, set_select_field_dimensions] = useState(['1']);
    const [colSpan, set_colSpan] = useState(1);
    const [field_dimensions_table, set_field_dimensions_table] = useState([]);
    const [data_Statistics, setData_Statistics] = useState([]);
    const [processed_Data, set_Processed_Data] = useState([]);

    const exportTableToExcel = (tableID, filename = '') => {
        let workbook = new excel.Workbook();
        let worksheet = workbook.addWorksheet('RevenueReport');
        // worksheet.columns = processed_Data.statistics[0].map((s) => ({
        //     header: s['name'],
        //     key: s['name'],
        //     width: 15,
        // }));
        worksheet.columns = [
            ...processed_Data.statistics[0]
                .filter(
                    (item) =>
                        (item.type == 'metric' && field_select_metrics.includes(item.id.toString())) ||
                        item.type != 'metric'
                )
                .map((s) => ({
                    header: s['name'],
                    key: s['name'],
                    width: 15,
                })),
        ];
        for (let i = 0; i < processed_Data.statistics.length; ++i) {
            const statistic = processed_Data.statistics[i];
            let rowExcel = {};
            for (const dataRow of statistic) {
                rowExcel = Object.assign(rowExcel, {
                    [dataRow['name']]: formatNumber(dataRow['value']),
                });
            }
            worksheet.addRows([rowExcel]);
        }

        let rowExcel = {};

        rowExcel[worksheet.getCell('A1').value] = 'Tổng';

        for (const dataRow of processed_Data.total) {
            rowExcel = Object.assign(rowExcel, {
                [dataRow['name']]: formatNumber(dataRow['value']),
            });
        }
        worksheet.addRows([rowExcel]);
        let lastRowIndex = worksheet.rowCount;
        let endColumnLetter = String.fromCharCode('A'.charCodeAt(0) + colSpan - 1);
        worksheet.mergeCells(`A${lastRowIndex}:${endColumnLetter}${lastRowIndex}`);

        // Use exceljs to write the workbook to a file
        workbook.xlsx
            .writeBuffer()
            .then((buffer) => {
                const file = new Blob([buffer], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = URL.createObjectURL(file);

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // IE/Edge
                    window.navigator.msSaveOrOpenBlob(
                        file,
                        filename !== '' ? filename + '.xlsx' : 'SuDungDichVu.xlsx'
                    );
                } else {
                    // Other browsers
                    window.open(url);
                }

                URL.revokeObjectURL(url); // Giải phóng tài nguyên
            })
            .catch((error) => {
                console.error('Error writing file:', error);
            });
    };

    const onAddGraphical = async (metric, dimention) => {
        set_isLoading(true);
        const graphical_Statistics = await get_Data_Good_Day_usage_graphical({
            userTypeId: UserType_Apply.map((item) => item.id),
            workIds: thingsToSee_Apply.map((item) => item.id),
            startTime: formatDate(startDate, 'dd/MM/yyyy'),
            endTime: formatDate(endDate, 'dd/MM/yyyy'),
            metricIds: [metric],
            dimensionIds: dimention == 0 ? [] : [dimention],
        });

        let list_graphical = [...list_graphical_Statistics];
        list_graphical.push(graphical_Statistics.data.data);
        let units = [...list_unit];
        units.push(graphical_Statistics.data.data.unit);
        set_list_Graphical_Statistics(list_graphical);
        set_list_Unit(units);

        let list_Metric = [...selectedMetric];
        list_Metric.push(metric);
        let list_Dimension = [...selectDimension];
        list_Dimension.push(dimention);

        setSelectedMetric(list_Metric);
        setSelectedDimension(list_Dimension);

        set_isLoading(false);
    };
    const [is_Popup, set_Popup] = useState(false);
    const onClosePopup = () => {
        set_Popup(false);
    };
    const CallPopup = async () => {
        set_Popup(true);
        //call popup
    };

    useEffect(() => {
        const feee = async () => {
            // const Multi_Services = await get_services();
            // setUserType(Multi_Services.data.data);

            const worklist = await get_getGoodDaySelectionWorkList();
            setThingsToSee(worklist.data.data);
            set_service_packages(worklist.data.data);

            const metrics = await get_metrics(5);
            set_field_metrics(metrics.data.data);
            set_select_field_metrics(metrics.data.data.map((item) => item.id));

            const dimensions = await get_dimensions(5);
            set_field_dimensions(dimensions.data.data);

            await initgraphical();

            const data_Statistics = await get_Data_Good_Day_usage_data({
                workIds: [],
                userTypeId: [0],
                startTime: formatDate(startDate, 'dd/MM/yyyy'),
                endTime: formatDate(endDate, 'dd/MM/yyyy'),
                metricIds: [1, 2],
                dimensionIds: [1],
            });

            set_field_dimensions_table(data_Statistics.data.data.statistics[0]);

            setData_Statistics(data_Statistics.data.data);
            set_isLoading(false);
        };
        feee();
    }, []);
    const initgraphical = async () => {
        let list_graphical = [...list_graphical_Statistics];
        // Initialize the variable before using it
        let units = []; // Do the same for list_unit

        const graphical_Statistics1 = await get_Data_Good_Day_usage_graphical(
            {
                workIds: [],
                userTypeId: [0],
                startTime: formatDate(startDate, 'dd/MM/yyyy'),
                endTime: formatDate(endDate, 'dd/MM/yyyy'),
                metricIds: [
                    1
                ],
                dimensionIds: [

                ]
            }
        );

        list_graphical.push(graphical_Statistics1.data.data);
        units = [...list_unit];
        units.push(graphical_Statistics1.data.data.unit);
        set_list_Graphical_Statistics(list_graphical);
        set_list_Unit(units);
    };
    const handleDeleteChart = (index) => {
        const newList = [...list_graphical_Statistics];
        newList.splice(index, 1);
        set_list_Graphical_Statistics(newList);

        let list_Metric = [...selectedMetric];
        list_Metric.splice(index, 1);
        let list_Dimension = [...selectDimension];
        list_Dimension.splice(index, 1);

        setSelectedMetric(list_Metric);
        setSelectedDimension(list_Dimension);
    };

    const formatNumber = (value) => {
        if (value == null) {
            return '';
        }
        if (!isNaN(value)) {
            return Number(value).toLocaleString();
        }
        return value.toString();
    };

    const fetchGraphicalStatisticsChild = async () => {
        let list_graphical = [...list_graphical_Statistics];
        let units = [...list_unit];

        for (let i = 0; i < list_graphical_Statistics.length; i++) {
            const graphical_Statistics = await get_Data_Good_Day_usage_graphical({
                userTypeId: selectedUserType.map((item) => item.id),
                workIds: selectedThingsToSee.map((item) => item.id),
                startTime: formatDate(startDate, 'dd/MM/yyyy'),
                endTime: formatDate(endDate, 'dd/MM/yyyy'),
                metricIds: [selectedMetric[i]],
                dimensionIds: selectDimension[i] == 0 || selectDimension[i] == null ? [] : [Number(selectDimension[i])],
            });

            list_graphical[i] = graphical_Statistics.data.data;
            units[i] = graphical_Statistics.data.data.unit;
        }
        await set_list_Graphical_Statistics(list_graphical);
        await set_list_Unit(units);
    };

    const fetchGraphicalStatistics = async () => {
        set_isLoading(true);

        setIsAscendings([
            { id: 1, value: false, type: 'dimension' },
            { id: 1, value: null, type: 'metric' },
            { id: 2, value: null, type: 'metric' },
            { id: 3, value: null, type: 'metric' },
        ]);

        set_endDate_Apply(endDate);
        set_startDate_Apply(startDate);
        set_UserType_Apply(selectedUserType);
        set_thingsToSee_Apply(selectedThingsToSee);

        // console.log(startDate);
        const data_Statistics = await get_Data_Good_Day_usage_data({
            userTypeId: selectedUserType.map((item) => item.id),
            workIds: selectedThingsToSee.map((item) => item.id),
            startTime: formatDate(startDate, 'dd/MM/yyyy'),
            endTime: formatDate(endDate, 'dd/MM/yyyy'),
            metricIds: [1, 2],
            dimensionIds: field_select_dimensions.map((item) => Number(item)),
        });

        if (data_Statistics.data.data.statistics.length == 0) {
            set_colSpan(1);
        }

        set_field_dimensions_table(data_Statistics.data.data.statistics[0]);
        setData_Statistics(data_Statistics.data.data);

        await fetchGraphicalStatisticsChild();
        set_isLoading(false);
    };

    const fetchTableStatistics = async () => {
        if (field_select_dimensions.length == 0) {
            return;
        }
        set_isLoading(true);

        const data_Statistics = await get_Data_Good_Day_usage_data({
            userTypeId: UserType_Apply.map((item) => item.id),
            workIds: thingsToSee_Apply.map((item) => item.id),
            startTime: formatDate(startDate_Apply, 'dd/MM/yyyy'),
            endTime: formatDate(endDate_Apply, 'dd/MM/yyyy'),
            metricIds: [1, 2],
            dimensionIds: field_select_dimensions.map((item) => Number(item)).sort((a, b) => a - b),
        });
        if (data_Statistics.data.data.statistics.length == 0) {
            set_colSpan(1);
            set_isLoading(false);
            return;
        }

        set_colSpan(field_select_dimensions.length);
        set_field_dimensions_table(data_Statistics.data.data.statistics[0]);

        setData_Statistics(data_Statistics.data.data);

        set_isLoading(false);
    };

    const onChangeSelectTable = async (type, id, status) => {
        switch (type) {
            case 'dimension':
                let dimension = [...field_select_dimensions];
                if (status) {
                    dimension.push(id);
                } else {
                    dimension = dimension.filter((item) => item != id);
                }
                set_select_field_dimensions(dimension);
                // console.log(dimension);
                break;
            case 'metric':
                let metric = [...field_select_metrics]; // Tạo một bản sao của mảng
                if (status) {
                    metric.push(id);
                } else {
                    metric = metric.filter((item) => item != id);
                }
                set_select_field_metrics(metric);
                // console.log(metric);
                break;
        }
    };

    useEffect(() => {
        set_Processed_Data({ ...data_Statistics });
        setCurrentPage(1);
    }, [data_Statistics]);

    const [isAscendings, setIsAscendings] = useState([
        { id: 1, value: false, type: 'dimension' },
        { id: 1, value: null, type: 'metric' },
        { id: 2, value: null, type: 'metric' },
        { id: 3, value: null, type: 'metric' },
    ]);

    const arrange_Data = (id, type) => {
        if (type == 'dimension') {
            let value = isAscendings.find((item) => item.id === id && item.type == type).value;

            let isAscending = value == null ? false : !value;

            let data = processed_Data.statistics;
            let sortedData = data.sort((a, b) => {
                let aValue = new Date(
                    a
                        .find((item) => item.type == type && item.id === id)
                        ?.value.split('/')
                        .reverse()
                        .join('/')
                );
                let bValue = new Date(
                    b
                        .find((item) => item.type == type && item.id === id)
                        ?.value.split('/')
                        .reverse()
                        .join('/')
                );

                if (isAscending) {
                    if (aValue < bValue) {
                        return -1;
                    }
                    if (aValue > bValue) {
                        return 1;
                    }
                } else {
                    if (aValue < bValue) {
                        return 1;
                    }
                    if (aValue > bValue) {
                        return -1;
                    }
                }
                return 0;
            });
            let aaa = { ...processed_Data };
            aaa.statistics = sortedData;
            set_Processed_Data(aaa);

            let newIsAscendings = [...isAscendings];
            let index = newIsAscendings.findIndex((item) => item.id === id && item.type === type);

            if (index !== -1) {
                newIsAscendings[index].value = isAscending;
            }
            for (let i = 0; i < newIsAscendings.length; i++) {
                if (i != index) newIsAscendings[i].value = null;
            }
            setIsAscendings(newIsAscendings);
            return;
        }
        let value = isAscendings.find((item) => item.id === id && item.type == type).value;

        let isAscending = value == null ? false : !value;

        let data = processed_Data.statistics;
        let sortedData = data.sort((a, b) => {
            let aValue = a.find((item) => item.type == type && item.id === id)?.value;
            let bValue = b.find((item) => item.type == type && item.id === id)?.value;

            if (isAscending) {
                if (aValue < bValue) {
                    return -1;
                }
                if (aValue > bValue) {
                    return 1;
                }
            } else {
                if (aValue < bValue) {
                    return 1;
                }
                if (aValue > bValue) {
                    return -1;
                }
            }
            return 0;
        });
        let aaa = { ...processed_Data };
        aaa.statistics = sortedData;
        set_Processed_Data(aaa);

        let newIsAscendings = [...isAscendings];
        let index = newIsAscendings.findIndex((item) => item.id === id && item.type === type);

        if (index !== -1) {
            newIsAscendings[index].value = isAscending;
        }
        for (let i = 0; i < newIsAscendings.length; i++) {
            if (i != index) newIsAscendings[i].value = null;
        }
        setIsAscendings(newIsAscendings);
    };

    return (
        <div className="container-fluid min-h-100">
            {is_Popup && (
                <AddGraphical
                    onChange={onAddGraphical}
                    onClose={onClosePopup}
                    dimensions={field_dimensions}
                    metrics={field_metrics}
                ></AddGraphical>
            )}
            {<Loading isLoading={isLoading} />}
            <div style={{ backgroundColor: 'white' }} className="card card-body">
                <h1 className="pt-5">
                    <b>SỬ DỤNG DỊCH VỤ</b>
                </h1>

                <div className="">
                    <div className="row">
                        <div className="col-sm">
                            <div className="card-toolbar gap-2 d-flex justify-content-end">
                                <div
                                    className="btn-primary btn font-weight-bold d-flex align-items-center flex gap-3"
                                    onClick={() => {
                                        checkPermissionFunction(path, 'export', () =>
                                            exportTableToExcel('myTable', '')
                                        );
                                    }}
                                >
                                    <i className="fa fa-file-download" />
                                    <span>Export</span>
                                </div>
                                <div
                                    className="btn-primary btn font-weight-bold d-flex align-items-center flex gap-3"
                                    onClick={CallPopup}
                                >
                                    <i className="fa fa-plus" />
                                    <span>Thêm biểu đồ</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div>
                    <div className="d-flex flex-column gap-4 container-fluid w-100vh pt-10">
                        <Row justify="space-between" className='flex justify-items-center items-end'>
                            <Col>
                                <div className='h-full'>
                                    <div className='h-full content-between'>
                                        <h4>Loại người dùng</h4>
                                        <div>
                                            <Select
                                                // options={UserType.map()}
                                                defaultValue={"0"}
                                                options={UserType.map((item) => {
                                                    return { label: item.name, value: item.id };
                                                })}
                                                onChange={(e) => {
                                                    console.log(e)
                                                    setSelectedUserType([{ id: Number(e) }])
                                                }}
                                            />
                                        </div>
                                    </div>

                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <h4>Thời gian sử dụng dịch vụ</h4>
                                    <div>
                                        <div className="btn border-dark" onClick={() => set_pickDate(!showPickDate)}>
                                            <span
                                                className="d-flex flex-row align-items-center justify-content-center btn-white font-weight-normal rounded-lg shadow-sm"
                                                style={{ whiteSpace: 'nowrap', fontSize: '1rem', fontWeight: '600' }}
                                            >
                                                <i className="far fa-calendar-alt" style={{ fontSize: '15px' }} />
                                                <span className="ms-2 me-2 mx-2 d-flex h-100 align-items-center">
                                                    {titleDay}
                                                </span>
                                                <i className="fa fa-angle-down" />
                                            </span>
                                        </div>
                                        <div className={showPickDate != true ? 'd-none' : ''}>
                                            <DateSelecter onDateChange={onDateChange} save={() => set_pickDate(false)} />
                                        </div>
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <h4>Việc cần xem</h4>
                                    <div>
                                        <Multiselect
                                            placeholder="Chọn"
                                            options={service_packages.filter((option) => option && option.name)}
                                            selectedValues={selectedThingsToSee}
                                            onSelect={onChangeSelectservicePackages}
                                            onRemove={onChangeSelectservicePackages}
                                            displayValue="name"
                                        />
                                    </div>
                                </div>
                            </Col>
                            <Col>
                                <div className='h-full justify-end flex items-end'>
                                    <Button
                                        type='primary'
                                        onClick={() => fetchGraphicalStatistics()}
                                    >
                                        Áp dụng
                                    </Button>

                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>

                <div>
                    <div className="row pt-10">
                        {list_graphical_Statistics &&
                            list_graphical_Statistics.map((item, index) => {
                                let colClass = 'col-12'; // Default is 1 chart per row
                                if (list_graphical_Statistics.length % 2 === 0) {
                                    colClass = 'col-12 col-lg-6'; // 2 charts per row if the number of charts is even
                                } else if (
                                    list_graphical_Statistics.length > 1 &&
                                    index < list_graphical_Statistics.length - 1
                                ) {
                                    colClass = 'col-12 col-lg-6'; // 2 charts per row for all charts except the last one if the number of charts is odd
                                }
                                return (
                                    <Fragment key={index}>
                                        <div key={index} className={`pt-5 ${colClass}`}>
                                            <div style={{ width: '99%', backgroundColor: 'white', borderRadius: '15px' }}>
                                                <div className="container">
                                                    <div className="row">
                                                        <div className="col-sm">
                                                            <div className="d-flex flex-row align-items-center gap-2 pt-5">
                                                                <b>Metrics</b>
                                                                <section
                                                                    onChange={(e) => onChangeSelect(e, 'metric', index)}
                                                                    className="overflow-auto"
                                                                >
                                                                    <select
                                                                        defaultValue={selectedMetric[index]}
                                                                        className="form-control custom-select shadow-none"
                                                                    >
                                                                        {field_metrics &&
                                                                            field_metrics.map((item, index) => {
                                                                                return (
                                                                                    <option value={item.id} key={item.id}>
                                                                                        {item.name}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                    </select>
                                                                </section>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm">
                                                            <div className="d-flex flex-row align-items-center gap-2 pt-5">
                                                                <b>Dimension</b>
                                                                <section
                                                                    onChange={(e) => onChangeSelect(e, 'dimension', index)}
                                                                    className="overflow-auto"
                                                                >
                                                                    <select
                                                                        defaultValue={selectDimension[index]}
                                                                        className="form-control custom-select shadow-none"
                                                                    >
                                                                        <option value={0} key={0}>
                                                                            Tất cả
                                                                        </option>
                                                                        {field_dimensions &&
                                                                            field_dimensions
                                                                                .filter((item) => item.id != 1)
                                                                                .map((item, index) => {
                                                                                    return (
                                                                                        <option value={item.id} key={item.id}>
                                                                                            {item.name}
                                                                                        </option>
                                                                                    );
                                                                                })}
                                                                    </select>
                                                                </section>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm d-flex flex-row align-items-center gap-2 pt-5">
                                                            {/* <div className='d-flex flex-row align-items-center gap-2 pt-5'> */}
                                                            <span
                                                                style={{ cursor: 'pointer' }}
                                                                className={index == 0 ? 'btn btn-danger d-none' : ''}
                                                                onClick={() => handleDeleteChart(index)}
                                                            >
                                                                <b style={{ color: 'red' }}>Xóa</b>
                                                            </span>
                                                            {/* </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="pt-5">
                                                    {/* <LineChart Unprocessed_Data={item} unit={list_unit[index]} /> */}
                                                    <MultiaxisLineChart Unprocessed_Data={item} unit={list_unit[index]} />
                                                    {/* <DemoMultiaxisLineChart /> */}
                                                </div>
                                                <div
                                                    className="row mx-n2 text-center mt-2 overflow-auto"
                                                    style={{ maxHeight: '20em' }}
                                                >
                                                    {item &&
                                                        item.total &&
                                                        item.total.map((item1, index1) => {
                                                            return (
                                                                <span key={index1} className="col-12 col-sm-6 col-md-4 px-2">
                                                                    <span>
                                                                        {item1.name}: {`${formatNumber(item1?.value)} ${item?.unit ?? ""}`}                                                                    </span>
                                                                </span>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                );
                            })}
                    </div>
                </div>
            </div>

            <div className="mt-20 card card-body">
                <div style={{ backgroundColor: 'white' }} className="row no-gutters pt-10 container-fluid">
                    <div className="col-10">
                        <div>
                            <table id="myTable" style={{ width: '95%' }} className="text-center">
                                <tbody>
                                    <tr>
                                        {
                                            field_dimensions_table &&
                                                field_dimensions_table.filter(
                                                    (item) =>
                                                        (field_select_metrics.includes(item.id.toString()) &&
                                                            item.type == 'metric') ||
                                                        item.type == 'dimension'
                                                ).length > 0 ? (
                                                field_dimensions_table
                                                    .filter(
                                                        (item) =>
                                                            (field_select_metrics.includes(item.id.toString()) &&
                                                                item.type == 'metric') ||
                                                            item.type == 'dimension'
                                                    )
                                                    .map((item, index) => {
                                                        return (
                                                            // style = {{ backgroundColor: "#00838F", color: 'white'}}
                                                            <td className="bg-info text-white text-center" key={index}>
                                                                <div className="d-flex justify-content-between">
                                                                    <span className="text-center d-block" style={{ width: '100%' }}>
                                                                        <b>{item.name}</b>
                                                                    </span>
                                                                    <span className="text-end">
                                                                        {(item.type == 'metric' ||
                                                                            (item.type == 'dimension' && item.id == 1)) && (
                                                                                <i
                                                                                    onClick={() => arrange_Data(item.id, item.type)}
                                                                                    className={`mr-2 fa fa${isAscendings.find(
                                                                                        (item1) =>
                                                                                            item1.id === item.id && item1.type == item.type
                                                                                    ).value === true
                                                                                        ? '-arrow-up'
                                                                                        : isAscendings.find(
                                                                                            (item1) =>
                                                                                                item1.id === item.id && item1.type == item.type
                                                                                        ).value === false
                                                                                            ? '-arrow-down'
                                                                                            : '-sort'
                                                                                        }`}
                                                                                    style={{ width: '1px', height: '1px', cursor: 'pointer' }}
                                                                                ></i>
                                                                            )}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        );
                                                    })
                                            ) : (
                                                <>
                                                    <td style={{ backgroundColor: '#00838F', color: 'white' }}>
                                                        <b>Ngày</b>
                                                    </td>
                                                    <td style={{ backgroundColor: '#00838F', color: 'white' }}>
                                                        <b>Doanh thu</b>
                                                    </td>
                                                    <td style={{ backgroundColor: '#00838F', color: 'white' }}>
                                                        <b>Số lượt mua</b>
                                                    </td>
                                                    <td style={{ backgroundColor: '#00838F', color: 'white' }}>
                                                        <b>Số người mua</b>
                                                    </td>
                                                </>
                                            ) // Replace this with your alternative content
                                        }
                                    </tr>
                                    {processed_Data.statistics &&
                                        processed_Data.statistics
                                            .slice(
                                                rowsPerPage * (currentPage - 1),
                                                processed_Data.statistics.length >= rowsPerPage * currentPage
                                                    ? rowsPerPage * currentPage
                                                    : processed_Data.statistics.length
                                            )
                                            .map((item1, index1) => {
                                                return (
                                                    <tr
                                                        style={{
                                                            color: `${index1 % 2 != 1 ? 'black' : 'black'}`,
                                                            backgroundColor: `${index1 % 2 != 1 ? 'white' : 'white'}`,
                                                        }}
                                                        key={index1}
                                                    >
                                                        {item1
                                                            .filter(
                                                                (item) =>
                                                                    (field_select_metrics.includes(item.id.toString()) &&
                                                                        item.type == 'metric') ||
                                                                    item.type == 'dimension'
                                                            )
                                                            .map((item2, index2) => {
                                                                return (
                                                                    <td key={index2}>
                                                                        <b>{formatNumber(item2.value)}</b>
                                                                    </td>
                                                                );
                                                            })}
                                                    </tr>
                                                );
                                            })}
                                    {/* style={{ color: `white`, backgroundColor: `#00838F` }} */}
                                    <tr className="bg-info text-white">
                                        <td colSpan={colSpan}>
                                            <b>Tổng</b>
                                        </td>
                                        {processed_Data.total &&
                                            processed_Data.total
                                                .filter(
                                                    (item) =>
                                                        (field_select_metrics.includes(item.id.toString()) &&
                                                            item.type == 'metric') ||
                                                        item.type == 'dimension'
                                                )
                                                .map((item, index) => {
                                                    return (
                                                        <td key={index}>
                                                            <b>{formatNumber(item.value)}</b>
                                                        </td>
                                                    );
                                                })}
                                    </tr>
                                </tbody>
                            </table>
                            <div className="container">
                                <Pagination
                                    rowsPerPage={rowsPerPage}
                                    rowCount={data_Statistics?.statistics?.length || 0}
                                    onChangePage={(newPage) => setCurrentPage(newPage)}
                                    onChangeRowsPerPage={(newRowsPerPage) => {
                                        setRowsPerPage(newRowsPerPage);
                                        setCurrentPage(1);
                                    }}
                                    currentPage={currentPage}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-2" style={{ alignItems: 'center' }}>
                        <div className="">
                            <b>Dimension</b>
                            {field_dimensions.map((item, index) => {
                                return (
                                    <div key={index} className="col d-flex align-items-center gap-2">
                                        <input
                                            style={{ accentColor: 'green' }}
                                            onClick={(e) => onChangeSelectTable('dimension', item.id, e.target.checked)}
                                            defaultChecked={item.id == 1}
                                            type="checkbox"
                                        />
                                        <span>{item.name}</span>
                                    </div>
                                );
                            })}
                            <b>Metrics</b>
                            {field_metrics.map((item, index) => {
                                return (
                                    <div key={index} className="col d-flex align-items-center gap-2">
                                        <input
                                            style={{ accentColor: 'green' }}
                                            onClick={(e) => onChangeSelectTable('metric', item.id, e.target.checked)}
                                            defaultChecked={item.id == 1 || item.id == 2 || item.id == 3}
                                            type="checkbox"
                                        />
                                        <span>{item.name}</span>
                                    </div>
                                );
                            })}
                        </div>

                        <div className="pt-5 text-center">
                            <span
                                onClick={fetchTableStatistics}
                                className={`btn-info btn w-50 ${field_select_dimensions.length == 0 || field_select_metrics.length == 0
                                    ? 'disabled'
                                    : ''
                                    }`}
                            >
                                Áp dụng
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default UseTheService;
